import * as actionTypes from "./actionTypes";

/**
 * Get invoices
 */

export type InvoicesType = Array<InvoiceType>;

export type InvoiceType = {
	readonly id: number;
	readonly debitDate: string;
	readonly invoiceId: string;
	readonly amount: number;
	readonly status: string;
	readonly scheduleAmount: string;
	readonly description: string;
};

export type GetInvoicesType = {
	readonly invoices: InvoicesType;
	readonly isGettingInvoices: boolean;
	readonly isGetInvoicesSuccess: boolean;
	readonly isGetInvoicesError: boolean;
};

export const getInvoicesDefaultValue: GetInvoicesType = {
	invoices: [],
	isGettingInvoices: false,
	isGetInvoicesSuccess: false,
	isGetInvoicesError: false,
};

export type GetInvoicesPayloadType = {
	readonly id: number;
};

export type GetInvoices = {
	(payload: GetInvoicesPayloadType): GetInvoicesActionTypes;
};

type GetInvoicesAction = {
	type: typeof actionTypes.GET_INVOICES;
	payload: GetInvoicesPayloadType;
};

type GetInvoicesSuccessAction = {
	type: typeof actionTypes.GET_INVOICES_SUCCESS;
};

type GetInvoicesFailureAction = {
	type: typeof actionTypes.GET_INVOICES_FAILURE;
};

export type GetInvoicesActionTypes = GetInvoicesAction | GetInvoicesSuccessAction | GetInvoicesFailureAction;

/**
 * Download invoice
 */

export type DownloadInvoiceType = {
	readonly index: number;
	readonly isDownloadingInvoice: boolean;
	readonly isDownloadInvoiceSuccess: boolean;
	readonly isDownloadInvoiceError: boolean;
	readonly downloadInvoiceError: string;
};

export const downloadInvoiceDefaultValue: DownloadInvoiceType = {
	index: -1,
	isDownloadingInvoice: false,
	isDownloadInvoiceSuccess: false,
	isDownloadInvoiceError: false,
	downloadInvoiceError: "",
};

export type DownloadInvoicePayloadType = {
	readonly id: number;
	readonly index: number;
};

export type DownloadInvoice = {
	(payload: DownloadInvoicePayloadType): GetInvoicesActionTypes;
};

type DownloadInvoiceAction = {
	type: typeof actionTypes.DOWNLOAD_INVOICE;
	payload: DownloadInvoicePayloadType;
};

type DownloadInvoiceSuccessAction = {
	type: typeof actionTypes.DOWNLOAD_INVOICE_SUCCESS;
	payload: DownloadInvoicePayloadType;
};

type DownloadInvoiceFailureAction = {
	type: typeof actionTypes.DOWNLOAD_INVOICE_FAILURE;
	payload: DownloadInvoicePayloadType;
};

export type DownloadInvoiceActionTypes =
	| DownloadInvoiceAction
	| DownloadInvoiceSuccessAction
	| DownloadInvoiceFailureAction;
